import { render, staticRenderFns } from "./FocusedDashboardShell.vue?vue&type=template&id=32a05a21&scoped=true"
import script from "./FocusedDashboardShell.vue?vue&type=script&lang=js"
export * from "./FocusedDashboardShell.vue?vue&type=script&lang=js"
import style0 from "./FocusedDashboardShell.vue?vue&type=style&index=0&id=32a05a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a05a21",
  null
  
)

export default component.exports